import React, { useRef, useState } from "react";
import Loading from "../../../cross/Loading";
import { EnumEstadoDesviacion } from "../../../entities/helper/EnumEstadoDesviacion";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import { ICausaBasica } from "../../../entities/ICausaBasica";
import { ICausaInmediata } from "../../../entities/ICausaInmediata";
import { ICausaSistema } from "../../../entities/ICausaSistema";
import { IDesviacion } from "../../../entities/IDesviacion";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import DesviacionService from "../../../services/DesviacionService";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import Swal, { SweetAlertResult } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { dateFormatInputReference, shortDate } from "../../../helpers/dateHelper";
import AgregarAnalisisCausalInmediato from "./AgregarAnalisisCausalInmediato";
import AgregarAnalisisCausalBasica from "./AgregarAnalisisCausalBasica";
import IDocumentoDesviacion, { IEvidenciasArbolCausal } from "../../../entities/IDocumentoDesviacion";
import AgregarAnalisisCausalSistema from "./AgregarAnalisisCausalSistema";
import { Col, Row } from "react-bootstrap";
import { getFileName } from "../../../helpers/pathHelper";
import { E_EstadoCausa } from "../../../enums/E_EstadoCausa";
import { E_EstadoFormCausaDesviacion, E_EstadoFormRegistrarCierreDesv } from "../../../enums/E_EstadoFormulario";
import { E_TipoDocumentoDesviacion } from "../../../enums/E_TIpoDocumentoDesviacion";
import { ROW_COUNT } from "../../../helpers/variableHelper";
import { cognitoUserInfo } from "../../../helpers/userHelper";
import { AdminListaPagination, IPagination } from "../../../controls/AdminListaPagination";
import { ETipoDesviacion } from "../../../enums/E_TipoDesviacion";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import IAuditoria from "../../../entities/IAuditoria";
const MySwal = withReactContent(Swal);
interface IDesviacionRegistrarCierreProps {
  token: string;
  readonly: boolean;
  is_test?: boolean;
  loading?: boolean;
  items1?: Array<ICausaInmediata>;
  items2?: Array<ICausaBasica>;
  items3?: Array<ICausaSistema>;
  id_desv?: string;
  docs?: Array<IDocumentoDesviacion>;
  selectedAudit: IAuditoria | null;
}
export default function DesviacionRegistrarCierre({
  token,
  readonly,
  loading,
  items1,
  items2,
  items3,
  is_test,
  id_desv,
  docs,
  selectedAudit,
}: IDesviacionRegistrarCierreProps) {
  // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 117 como valor de complejidad cognitiva. Esta función realiza varias validaciones para la carga de las acciones, y para manejar las pruebas unitarias".
  let search = new URLSearchParams(window.location.search);
  const idDesviacion = parseInt(search.get("id") || (id_desv ?? "0"));
  const [selectedDesviacion, setSelectedDesviacion] = useState<IDesviacion | null>(null);
  const [isLoading, setIsLoading] = useState(loading ?? true);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(loading ?? true);

  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [listCausasInmediatas, setListCausasInmediatas] = useState<Array<ICausaInmediata>>(items1 ?? []);
  const [listCausasBasicas, setListCausasBasicas] = useState<Array<ICausaBasica>>(items2 ?? []);
  const [listCausasSistema, setListCausasSistema] = useState<Array<ICausaSistema>>(items3 ?? []);

  const [isOpenAddCI, setIsOpenAddCI] = useState<boolean>();
  const [isOpenAddCB, setIsOpenAddCB] = useState<boolean>();
  const [isOpenAddCS, setIsOpenAddCS] = useState<boolean>();
  const [obs, setObs] = useState("");
  const [estadoModalCausa, setEstadoModalCausa] = useState<E_EstadoFormCausaDesviacion>(E_EstadoFormCausaDesviacion.Lectura);
  const [selectdCausaBasica, setSelectedCausaBasica] = useState<ICausaBasica | null>(null);
  const [selectdCausaInmediata, setSelectedCausaInmediata] = useState<ICausaInmediata | null>(null);
  const [selectdCausaSistema, setSelectedCausaSistema] = useState<ICausaSistema | null>(null);

  const [isRejected, setRejected] = useState<boolean>(false);
  const refTxtDescripcionDocumento = React.createRef<HTMLTextAreaElement>();
  const refInptDocumentoAC = React.createRef<HTMLInputElement>();
  const refInptFechaEstimadaCierre = React.createRef<HTMLInputElement>();
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [isRequiredObservacion, setIsRequiredObservacion] = useState(false);
  const [listadoDocumentosPlan, setListadoDocumentosPlan] = useState<Array<IDocumentoDesviacion>>(docs ?? []);
  const [isSendingData, setIsSendingData] = useState(false);
  const [valPlanAccion, setValPlanAccion] = useState(is_test ?? false);
  const [estadoFormulario, setEstadoFormulario] = useState<E_EstadoFormRegistrarCierreDesv>(E_EstadoFormRegistrarCierreDesv.Lectura);
  const [isFlujoCorto, setIsFlujoCorto] = useState<boolean>(false);
  const totalPagesListCausasI = useRef<number>(0);
  const totalPagesListCausasB = useRef<number>(0);
  const totalPagesListCausasS = useRef<number>(0);
  const totalPagesDocuments = useRef<number>(0);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentEstadoFormulario = () => {
    if (selectedDesviacion?.RESPONSABLE_CIERRE !== null || selectedDesviacion?.AUDITORES_ACOMPANANTES !== null) {
      return selectedDesviacion?.RESPONSABLE_CIERRE === currentUser?.email ||
        isParticipatingAudit(selectedAudit?.AUDITORES_ACOMPANANTES, currentUser?.email)
        ? true
        : false;
    } else {
      return selectedDesviacion?.RESPONSABLE_INVESTIGACION === currentUser?.email;
    }
  };

  const isParticipatingAudit = (users: string | undefined, emailUser: string | undefined) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  const componentEliminar = (info: any) => {
    return (
      <i
        className="bi bi-trash iconSearch"
        title="Ver Desviación"
        onClick={() => {
          MySwal.fire({
            text: `¿Está seguro que desea eliminar el documento?`,
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result: SweetAlertResult) => {
            if (result.isConfirmed) {
              await DesviacionService.deleteDocumentoPlanAccion(token, info.row.original.ID as number);
              await loadDocumentsPlanAccion();
            }
          });
        }}></i>
    );
  };

  const componentVer = (value: any) => {
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        onClick={() => {
          DesviacionService.getContenidoDocumentoAnalisCausal(token, value.row.original.URL);
        }}></i>
    );
  };

  const componentAcciones = (value: any, tipo: ETipoCausa) => {
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        data-testid="btnverdesviacion"
        onClick={() => {
          if (
            (selectedDesviacion?.ID_ESTADO === EnumEstadoDesviacion.VerificacionCierreAcciones ||
              selectedDesviacion?.ID_ESTADO === EnumEstadoDesviacion.VerificacionCausasRechazadas) &&
            value.row.original.ID_ESTADO === E_EstadoCausa.AccionRealizada
          ) {
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Cerrar);
          } else if (value.row.original.ID_ESTADO == null) {
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Agregar);
          } else {
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
          }

          if (tipo === ETipoCausa.Inmediata) {
            setSelectedCausaInmediata(value.row.original as ICausaInmediata);
            setIsOpenAddCI(true);
          } else if (tipo === ETipoCausa.Basica) {
            setSelectedCausaBasica(value.row.original as ICausaBasica);
            setIsOpenAddCB(true);
          } else {
            setSelectedCausaSistema(value.row.original as ICausaSistema);
            setIsOpenAddCS(true);
          }
        }}></i>
    );
  };
  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    if (idDesviacion) {
      let resultDesviacion = await DesviacionService.getDesvicacionByID(token, idDesviacion);
      console.log("resultDesviacion", resultDesviacion);
      setSelectedDesviacion(resultDesviacion);

      setEstadoFormulario(
        resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.VerificacionCierreAcciones ||
          resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.VerificacionCausasRechazadas
          ? E_EstadoFormRegistrarCierreDesv.Cerrar
          : E_EstadoFormRegistrarCierreDesv.Lectura
      );
      setValPlanAccion(resultDesviacion?.PLAN_ACCION || false);
      await loadDocumentsPlanAccion();
      setIsLoading(false);
      setIsLoadingDocuments(false);
      refreshTable(undefined, resultDesviacion?.ID_ESTADO);
      setIsFlujoCorto(
        !(
          resultDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.NoConformidad ||
          (resultDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.Observacion &&
            resultDesviacion?.ID_POTENCIALIDAD === ETipoDesviacion.Conformidad) ||
          resultDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.OportunidadMejora
        ) || resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroCausasInmediatas
      );
    }
  }, []);

  const refreshTable = async (pagination?: IPagination, id_estado?: number) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    const resultListInmediata = is_test
      ? { data: items1 ?? [], pages: 10 }
      : await DesviacionService.getListadoCausaInmediata(token, {
          ID: idDesviacion,
          ...defaultPagination,
        });
    setListCausasInmediatas(resultListInmediata.data);
    const resultListBasica = is_test
      ? { data: items2 ?? [], pages: 10 }
      : await DesviacionService.getListadoCausaBasica(token, {
          ID: idDesviacion,
          ...defaultPagination,
        });
    setListCausasBasicas(resultListBasica.data);
    const resultListSistema = is_test
      ? { data: items3 ?? [], pages: 10 }
      : await DesviacionService.getListadoCausaSistema(token, {
          ID: idDesviacion,
          ...defaultPagination,
        });
    setListCausasSistema(resultListSistema.data);
    totalPagesListCausasI.current = resultListInmediata.pages;
    totalPagesListCausasB.current = resultListBasica.pages;
    totalPagesListCausasS.current = resultListSistema.pages;

    if (
      resultListInmediata.data.some((i) => i.ID_ESTADO === E_EstadoCausa.Rechazada) ||
      resultListBasica.data.some((b) => b.ID_ESTADO === E_EstadoCausa.Rechazada) ||
      resultListSistema.data.some((s) => s.ID_ESTADO === E_EstadoCausa.Rechazada)
    ) {
      setRejected(true);
    }
    if (
      resultListInmediata.data.some((i) => i.ID_ESTADO === E_EstadoCausa.CerradoObservacion) ||
      resultListBasica.data.some((b) => b.ID_ESTADO === E_EstadoCausa.CerradoObservacion) ||
      resultListSistema.data.some((s) => s.ID_ESTADO === E_EstadoCausa.CerradoObservacion)
    ) {
      setIsRequiredObservacion(true);
    }

    if (
      id_estado === EnumEstadoDesviacion.CerradoObservaciones &&
      resultListInmediata.data.some((i) => i.ID_ESTADO === E_EstadoCausa.CerradoObservacion || i.ID_ESTADO === E_EstadoCausa.Cerrado) &&
      resultListBasica.data.some((b) => b.ID_ESTADO === E_EstadoCausa.CerradoObservacion || b.ID_ESTADO === E_EstadoCausa.Cerrado) &&
      resultListSistema.data.some((s) => s.ID_ESTADO === E_EstadoCausa.CerradoObservacion || s.ID_ESTADO === E_EstadoCausa.Cerrado)
    ) {
      setEstadoFormulario(E_EstadoFormRegistrarCierreDesv.Lectura);
    }
  };

  //Columns Causa Inmediata
  const columnHelperCI = createColumnHelper<ICausaInmediata>();
  enum ETipoCausa {
    Inmediata = 1,
    Basica = 2,
    Sistema = 3,
  }
  const getColumns = (tipo: ETipoCausa) => {
    return [
      columnHelperCI.accessor((row: ICausaInmediata) => row.CORRELATIVO, {
        id: "CODIGO",
        cell: (info: CellContext<ICausaInmediata, string>) => componentValue(info.getValue()),
        header: () => component("Código"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperCI.accessor((row) => row.RESPONSABLE_DISPLAY, {
        id: "RESPONSABLE_DISPLAY",
        cell: (info: CellContext<ICausaInmediata, string>) => componentValue(info.getValue()),
        header: () => component("Responsable"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperCI.accessor((row) => row.FECHA_ASIGNACION, {
        id: "FECHA_ASIGNACION",
        cell: (info: CellContext<ICausaInmediata, Date>) => componentValue(shortDate(info.getValue())),
        header: () => component("Fecha de Asignación"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperCI.accessor((row) => row.FECHA_HASTA, {
        id: "PLAZO",
        cell: (info: CellContext<ICausaInmediata, Date>) => componentValue(shortDate(info.getValue())),
        header: () => component("Plazo"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperCI.accessor((row: ICausaInmediata) => row.ACCION, {
        id: "ACCION",
        cell: (info: CellContext<ICausaInmediata, string>) => componentValue(info.getValue()),
        header: () => component("Descripción"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperCI.accessor((row: ICausaInmediata) => row.FECHA_ACCION_REALIZADA, {
        id: "FECHA_ACCION_REALIZADA",
        cell: (info: CellContext<ICausaInmediata, Date>) => componentValue(shortDate(info.getValue())),
        header: () => component("Fecha de acción realizada"),
        tipo: ITipo_Campo.text,
      } as any),

      columnHelperCI.accessor((row: ICausaInmediata) => row.FECHA_INGRESO_ACCION_REALIZADA, {
        id: "FECHA_INGRESO_ACCION_REALIZADA",
        cell: (info: CellContext<ICausaInmediata, Date>) => componentValue(shortDate(info.getValue())),
        header: () => component("Fecha de ingreso acción realizada"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperCI.accessor((row: ICausaInmediata) => row.ESTADO, {
        id: "ESTADO",
        cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
        header: () => component("Estado"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperCI.accessor((row) => row.ID, {
        id: "VER",
        cell: (info: CellContext<ICausaInmediata | ICausaBasica | ICausaSistema, string>) => componentAcciones(info, tipo),
        header: () => component("Acciones"),
        tipo: ITipo_Campo.text,
        disableSorting: true,
      } as any),
    ] as any;
  };

  const validateRegistrarCierre = () => {
    let arrErrors = [];
    let msjError = [];

    if (
      listCausasBasicas.some((cb) => cb.ID_ESTADO === E_EstadoCausa.AccionRealizada || cb.ID_ESTADO === E_EstadoCausa.Asignada) ||
      listCausasSistema.some((cs) => cs.ID_ESTADO === E_EstadoCausa.AccionRealizada || cs.ID_ESTADO === E_EstadoCausa.Asignada) ||
      listCausasInmediatas.some((ci) => ci.ID_ESTADO === E_EstadoCausa.AccionRealizada || ci.ID_ESTADO === E_EstadoCausa.Asignada)
    ) {
      msjError.push(`Debe cerrar todas las acciones antes de cerrar la desviación.`);
      arrErrors.push("CERRAR_ACCIONES");
    }

    if (valPlanAccion && listadoDocumentosPlan.length === 0) {
      msjError.push(`Adjuntar Evidencia.`);
      arrErrors.push("ADJUNTAR_EVIDENCIA");
    }
    if (valPlanAccion && !refInptFechaEstimadaCierre.current?.value) {
      msjError.push(`Ingrese fecha estimada para el cierre.`);
      arrErrors.push("FECHA_ESTIMACION_CIERRE_PLAN_ACCION");
    }
    if (isRejected) {
      arrErrors.push("RECHAZADAS");
      msjError.push(`Debe cerrar todas las acciones antes de cerrar la desviación`);
    }

    if (
      (listCausasBasicas.some((cb) => cb.ID_ESTADO === E_EstadoCausa.CerradoObservacion) ||
        listCausasSistema.some((cs) => cs.ID_ESTADO === E_EstadoCausa.CerradoObservacion) ||
        listCausasInmediatas.some((ci) => ci.ID_ESTADO === E_EstadoCausa.CerradoObservacion)) &&
      !obs
    ) {
      msjError.push(`Para cerrar la Desviación, debe ingresar una observación.`);
      arrErrors.push("OBSERVACION");
    }

    if (arrErrors.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <p>
              <strong>Error Ingreso de datos:</strong>
            </p>
            {msjError.map((me) => (
              <p key={me}>{me}</p>
            ))}
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
      });
    }
    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const confirmed = async (fecha_cierre: Date) => {
    let idEstado = null;
    if (isRequiredObservacion && !valPlanAccion) {
      idEstado = EnumEstadoDesviacion.CerradoObservaciones;
    } else if (valPlanAccion) {
      idEstado = EnumEstadoDesviacion.CerradoPlanAccion;
    } else {
      idEstado = EnumEstadoDesviacion.Cerrado;
    }
    setIsSendingData(true);
    await DesviacionService.postCierreDesviacion(token, {
      ID: selectedDesviacion?.ID as number,
      CERRADO_CON_OBSERVACION: isRequiredObservacion,
      EDITOR: currentUser?.email as string,
      EDITOR_DISPLAY: currentUser?.fullname as string,
      FECHA_CIERRE: new Date(),
      FECHA_CIERRE_REF: new Date(),
      FECHA_ESTIMACION_CIERRE_PLAN_ACCION: fecha_cierre,
      FECHA_MODIFICACION: new Date(),
      ID_ESTADO: idEstado,
      OBSERVACION: obs,
      PLAN_ACCION: valPlanAccion,
      REQUIERE_CAMBIO_ESTADO: true,
      RESPONSABLE_CIERRE: currentUser?.email as string,
      RESPONSABLE_CIERRE_DISPLAY: currentUser?.fullname as string,
    });
    window.location.href = "/desviacion";
  };
  const handleRegistrarCierre = async () => {
    let fecha_cierre = new Date(refInptFechaEstimadaCierre.current?.value as string);
    if (validateRegistrarCierre()) {
      MySwal.fire({
        html: (
          <div>
            <h3>¿Desea cerrar la desviación?</h3>
          </div>
        ),
        icon: "question",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showCloseButton: true,
        showCancelButton: true,
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          confirmed(fecha_cierre);
        }
      });
    }
  };
  const loadDocumentsPlanAccion = async (params?: any) => {
    if (!params) {
      setIsLoadingDocuments(true);
      params = {
        ID_DESVIACION: idDesviacion,
        ORDENADOPOR: "ID",
        ORIENTACION: "DESC",
        PAGINA: 1,
        PAGINADO: ROW_COUNT,
        ID_TIPO_DOCUMENTO: E_TipoDocumentoDesviacion.ArbolCausal,
      };
    } else {
      params.ID_TIPO_DOCUMENTO = E_TipoDocumentoDesviacion.ArbolCausal;
      params.ID_DESVIACION = idDesviacion;
      params.URL = params.NOMBRE_DOCUMENTO;
      params.ORDENADOPOR = "ID";
      params.ORIENTACION = "DESC";
      params.PAGINA = 1;
      params.PAGINADO = ROW_COUNT;
    }

    let resultListadoDocumentosPA = is_test ? docs ?? [] : await DesviacionService.getListadoDocumentosPlanAccion(token, params);
    setListadoDocumentosPlan(resultListadoDocumentosPA);
    setIsLoadingDocuments(false);
  };

  const handleUploadDocument = async () => {
    let f = is_test ? {} : ((refInptDocumentoAC.current?.files as FileList)[0] as any);
    let value: Partial<IDocumentoDesviacion> = {
      ID_TIPO_DOCUMENTO: E_TipoDocumentoDesviacion.PlanAccion,
      ID_DESVIACION: selectedDesviacion?.ID as number,
      DESCRIPCION: refTxtDescripcionDocumento.current?.value,
      FILE: f,
    };
    await DesviacionService.postDocumentoPlanAccion(token, value);
    console.log(refInptFechaEstimadaCierre);
    await DesviacionService.postCierreDesviacion(token, {
      ID: selectedDesviacion?.ID as number,
      CERRADO_CON_OBSERVACION: true,
      EDITOR: currentUser?.email as string,
      EDITOR_DISPLAY: currentUser?.fullname as string,
      FECHA_ESTIMACION_CIERRE_PLAN_ACCION: new Date(refInptFechaEstimadaCierre.current?.value as string),
      FECHA_MODIFICACION: new Date(),
      ID_ESTADO: selectedDesviacion?.ID_ESTADO,
      OBSERVACION: obs,
      PLAN_ACCION: valPlanAccion,
      REQUIERE_CAMBIO_ESTADO: false,
    });
    try {
      (refTxtDescripcionDocumento.current as HTMLTextAreaElement).value = "";
      (refInptDocumentoAC.current as HTMLInputElement).value = "";
    } catch (e) {
      console.log(e);
    }
    await loadDocumentsPlanAccion();
  };

  const columnHelperEvidenciasCargadas = createColumnHelper<IEvidenciasArbolCausal>();

  let columnsDefPlanAccion = [
    columnHelperEvidenciasCargadas.accessor((row) => row.URL, {
      id: "NOMBRE_DOCUMENTO",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.CATEGORIA, {
      id: "CATEGORIA",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentValue("Árbol Causal"),
      header: () => component("Categoría"),
      tipo: ITipo_Campo.text,
      hide: true,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.ID, {
      id: "VER",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.ID, {
      id: "ELIMINAR",
      cell: (info: CellContext<IDesviacion, string>) => componentEliminar(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: estadoFormulario === E_EstadoFormRegistrarCierreDesv.Lectura,
    } as any),
  ] as any;

  return isLoading ? (
    <Loading />
  ) : (
    <div className="">
      <button
        data-testid="btnvalidate"
        hidden={true}
        onClick={() => {
          validateRegistrarCierre();
          confirmed(new Date());
        }}></button>
      <button
        data-testid="btndocspa"
        hidden={true}
        onClick={() => {
          loadDocumentsPlanAccion({});
          handleUploadDocument();
          handleRegistrarCierre();
        }}></button>

      <div className="container-fluid mb-4">
        <div className="card bg-light border p-3 pt-2 mt-2">
          <div className="row ajusteInput">
            <div className="col-12">
              <h6>
                <span className="textSeccion">Información de Registro de Cierre</span>
              </h6>
            </div>
            <div className="row ajusteInput">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <label>Estado Desviación</label>
                <p className="mb-2">{selectedDesviacion?.ESTADO}</p>
              </div>
            </div>
            {selectedDesviacion?.ESTADO === "Cerrado" && (
              <div className="row ajusteInput">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <label>Fecha de Cierre</label>
                  <p className="mb-2">{shortDate(selectedDesviacion?.FECHA_CIERRE)}</p>
                </div>
              </div>
            )}
            {selectedDesviacion?.ESTADO === "Cerrado" && (
              <div className="row ajusteInput">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <label>Cerrado por</label>
                  {selectedDesviacion?.ID_AUDITORIA ? (
                    <p className="mb-2">{selectedDesviacion?.RESPONSABLE_CIERRE_DISPLAY}</p>
                  ) : (
                    <p className="mb-2">{selectedDesviacion?.RESPONSABLE_INVESTIGACION_DISPLAY}</p>
                  )}
                </div>
              </div>
            )}
            <div className="col-sm-12 col-md-6 col-lg-6"></div>
          </div>
        </div>

        <div className="" id="collapseGeneradas">
          <div className="card card-body border-0 p-0 mt-2">
            <div className="row">
              <div className="col-12">
                <div className="container-fluid mb-4">
                  <h1 className="titPrincipal colorTit mt-2"></h1>

                  <div className="row">
                    {selectedDesviacion?.ID_TIPO_DESVIACION !== ETipoDesviacion.OportunidadMejora && (
                      <div className="col-12">
                        <h1 className="titPrincipal colorTit mt-2">Causas Inmediatas (Corrección)</h1>
                        <AdminListaPagination
                          defaultSortBy="ID"
                          sortDirection="DESC"
                          totalPages={totalPagesListCausasI}
                          callback={(pagination) => {
                            refreshTable(pagination);
                          }}
                          reload={() => {
                            refreshTable();
                          }}
                          columnsDef={getColumns(ETipoCausa.Inmediata)}
                          data={listCausasInmediatas || []}
                          hideAdd={true}
                          hideExport={true}
                        />
                      </div>
                    )}

                    {!isFlujoCorto && selectedDesviacion?.ID_TIPO_DESVIACION !== ETipoDesviacion.OportunidadMejora && (
                      <div className="col-12">
                        <h1 className="titPrincipal colorTit mt-2">Causas Básicas</h1>

                        <AdminListaPagination
                          defaultSortBy="ID"
                          sortDirection="DESC"
                          totalPages={totalPagesListCausasB}
                          callback={(pagination) => {
                            refreshTable(pagination);
                          }}
                          reload={() => {
                            refreshTable();
                          }}
                          columnsDef={getColumns(ETipoCausa.Basica)}
                          data={listCausasBasicas || []}
                          hideAdd={true}
                          hideExport={true}
                        />
                      </div>
                    )}

                    {selectedDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.OportunidadMejora && (
                      <div className="col-12">
                        <h1 className="titPrincipal colorTit mt-2">Ámbitos de Gestión</h1>
                        <AdminListaPagination
                          defaultSortBy="ID"
                          sortDirection="DESC"
                          totalPages={totalPagesListCausasS}
                          callback={(pagination) => {
                            refreshTable(pagination);
                          }}
                          reload={() => {
                            refreshTable();
                          }}
                          columnsDef={getColumns(ETipoCausa.Sistema)}
                          data={listCausasSistema || []}
                          hideAdd={true}
                          hideExport={true}
                        />
                      </div>
                    )}
                    {selectedDesviacion?.ID_TIPO_DESVIACION !== ETipoDesviacion.OportunidadMejora && (
                      <>
                        <div className="col-12 mt-2">
                          <label>Plan de acción</label>
                        </div>
                        <div className="col-12 mb-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="rdBtnPlanAccion"
                              defaultChecked={valPlanAccion}
                              onChange={() => {
                                setValPlanAccion(!valPlanAccion);
                              }}
                              disabled={estadoFormulario === E_EstadoFormRegistrarCierreDesv.Lectura}
                            />
                            <label className="form-check-label">Si</label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="rdBtnPlanAccion"
                              defaultChecked={!valPlanAccion}
                              onChange={() => {
                                setValPlanAccion(!valPlanAccion);
                              }}
                              disabled={estadoFormulario === E_EstadoFormRegistrarCierreDesv.Lectura}
                            />
                            <label className="form-check-label">No</label>
                          </div>
                        </div>
                      </>
                    )}
                    {valPlanAccion && (
                      <React.Fragment>
                        <Row>
                          <Col lg={3}>Fecha estimada de cierre de Plan de Acción</Col>
                          <Col>
                            <input
                              type="date"
                              ref={refInptFechaEstimadaCierre}
                              className={arrErrorEmpty.includes("FECHA_ESTIMACION_CIERRE_PLAN_ACCION") ? "error" : ""}
                              defaultValue={shortDate(selectedDesviacion?.FECHA_ESTIMACION_CIERRE_PLAN_ACCION, dateFormatInputReference) as string}
                              disabled={estadoFormulario === E_EstadoFormRegistrarCierreDesv.Lectura}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <div className="card bg-light border p-3 pt-2 mt-2">
                            <div className="row ajusteInput">
                              <div className="col-12">
                                <h6>
                                  <span className="textSeccion">Plan de acción</span>
                                </h6>
                              </div>
                              <div className="col-12">
                                {!isLoadingDocuments && estadoFormulario === E_EstadoFormRegistrarCierreDesv.Cerrar && (
                                  <div className="row mb-2 ajusteInput">
                                    <div className="row border m-1 p-1 rounded">
                                      <div className="col-sm-12 col-md-12 col-lg-5 mb-2">
                                        <label>Descripción</label>
                                      </div>
                                      <div className="col-sm-12 col-md-12 col-lg-7 mb-2">
                                        <textarea className="form-control form-control-sm" rows={3} ref={refTxtDescripcionDocumento}></textarea>
                                      </div>
                                      <div className="col-sm-12 col-md-12 col-lg-5 mb-2">
                                        <label>Adjuntar </label>
                                        <span className="text-danger">
                                          <small> Peso máximo (50 mb).</small>
                                        </span>
                                      </div>
                                      <div className="col-sm-12 col-md-12 col-lg-7 mb-2">
                                        <div className="input-group">
                                          <input
                                            type="file"
                                            className="form-control form-control-sm"
                                            id="inputGroupFile04"
                                            aria-describedby="inputGroupFileAddon04"
                                            aria-label="Seleccionar Archivos"
                                            ref={refInptDocumentoAC}
                                          />
                                          <button
                                            className="btn btn-primary btn-sm"
                                            type="button"
                                            id="inputGroupFileAddon04"
                                            onClick={() => {
                                              handleUploadDocument();
                                            }}>
                                            Subir
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <AdminListaPagination
                                  defaultSortBy="NOMBRE"
                                  totalPages={totalPagesDocuments}
                                  sortDirection="DESC"
                                  callback={(e: any) => {
                                    console.log(e);
                                  }}
                                  data={listadoDocumentosPlan}
                                  filter={(e: any) => {
                                    loadDocumentsPlanAccion(e);
                                  }}
                                  reload={(e: any) => {
                                    loadDocumentsPlanAccion();
                                  }}
                                  columnsDef={columnsDefPlanAccion}
                                  hideAdd={true}
                                  hideExport={true}
                                  isLoading={isLoadingDocuments}
                                />
                              </div>
                            </div>
                          </div>
                        </Row>
                      </React.Fragment>
                    )}

                    {(isRequiredObservacion || selectedDesviacion?.ID_ESTADO === EnumEstadoDesviacion.CerradoObservaciones) && (
                      <Row className="mt-3">
                        <Col lg={3}>
                          {estadoFormulario === E_EstadoFormRegistrarCierreDesv.Cerrar && (
                            <span className="text-danger">
                              <strong>(*)</strong>
                            </span>
                          )}
                          Observación
                        </Col>
                        <Col>
                          {estadoFormulario === E_EstadoFormRegistrarCierreDesv.Cerrar ? (
                            <textarea
                              onChange={(e) => setObs(e.currentTarget.value)}
                              className={`${arrErrorEmpty.includes("OBSERVACION") ? "error" : ""} form-control`}
                              defaultValue={selectedDesviacion?.OBSERVACION}
                            />
                          ) : (
                            <span>{selectedDesviacion?.OBSERVACION}</span>
                          )}
                        </Col>
                      </Row>
                    )}

                    {isSendingData ? (
                      <Loading />
                    ) : (
                      <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                        <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => (window.location.href = "/desviacion")}>
                          <i className="bi bi-arrow-left-circle me-2"></i> Volver
                        </button>

                        {estadoFormulario === E_EstadoFormRegistrarCierreDesv.Cerrar &&
                        componentEstadoFormulario() &&
                        selectedDesviacion?.ID_ESTADO !== EnumEstadoDesviacion.CerradoObservaciones &&
                        selectedDesviacion?.ID_ESTADO !== EnumEstadoDesviacion.Cerrado &&
                        selectedDesviacion?.ID_ESTADO !== EnumEstadoDesviacion.CerradoPlanAccion &&
                        !listCausasInmediatas.some(
                          (ci) => ci.ID_ESTADO !== E_EstadoCausa.Cerrado && ci.ID_ESTADO !== E_EstadoCausa.CerradoObservacion
                        ) &&
                        !listCausasBasicas.some(
                          (cb) => cb.ID_ESTADO !== E_EstadoCausa.Cerrado && cb.ID_ESTADO !== E_EstadoCausa.CerradoObservacion
                        ) &&
                        !listCausasSistema.some(
                          (cs) => cs.ID_ESTADO !== E_EstadoCausa.Cerrado && cs.ID_ESTADO !== E_EstadoCausa.CerradoObservacion
                        ) ? (
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              handleRegistrarCierre();
                            }}
                            disabled={isSendingData}>
                            <i className="bi bi-arrow-left-circle me-2"></i> Registrar Cierre
                          </button>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOpenAddCI && (
        <AgregarAnalisisCausalInmediato
          idDesviacion={idDesviacion}
          is_Test={is_test}
          token={token}
          onClose={() => {
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
            setSelectedCausaInmediata(null);
            setIsOpenAddCI(false);
          }}
          onSave={() => {
            refreshTable();
            setIsOpenAddCI(false);
          }}
          selectedAnalisisCausal={selectdCausaInmediata}
          estadoForm={estadoModalCausa}
          isVistaDetallada={true}
          isFlujoCorto={isFlujoCorto}
          selectedAudit={selectedAudit}
        />
      )}
      {isOpenAddCB && (
        <AgregarAnalisisCausalBasica
          idDesviacion={idDesviacion}
          responsable={selectedDesviacion?.RESPONSABLE_INVESTIGACION}
          responsableCierre={selectedDesviacion?.RESPONSABLE_CIERRE}
          token={token}
          onClose={() => {
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
            setSelectedCausaBasica(null);
            setIsOpenAddCB(false);
          }}
          onSave={() => {
            refreshTable();
            setIsOpenAddCB(false);
          }}
          selectedAnalisisCausalAC={selectdCausaBasica}
          estadoForm={estadoModalCausa}
          isVistaDetallada={true}
          selectedAudit={selectedAudit}
        />
      )}
      {isOpenAddCS && (
        <AgregarAnalisisCausalSistema
          idDesviacion={idDesviacion}
          responsable={selectedDesviacion?.RESPONSABLE_INVESTIGACION}
          responsableCierre={selectedDesviacion?.RESPONSABLE_CIERRE}
          token={token}
          onClose={() => {
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
            setSelectedCausaSistema(null);
            setIsOpenAddCS(false);
          }}
          onSave={() => {
            refreshTable();
            setIsOpenAddCS(false);
          }}
          selectedAnalisisCausalCS={selectdCausaSistema}
          estadoForm={estadoModalCausa}
          isVistaDetallada={true}
          selectedAudit={selectedAudit}
        />
      )}
    </div>
  );
}
